<template>
  <mw-dialog ref="dialog" :appendToBody="false" :size="size" :width="width" :height="height"  :customClass="params.type=='normal'?'mw-normal-form':'mw-flow-form'" :beforeClose="beforeClose" :title="title?title:''">
    <MwForm @getTitle="getTitle" @beforeRender="beforeRender"  :dialog="dialog" :initValue="params.initValue?params.initValue:{}" :propModuleId="params.moduleId" ref="form" :propFlowKey="params.key" :propAppId="params.appId"
            @configLoaded="formConfigLoaded" :propTempTableName="params.tempTableName" :propReadOnly="(params.readOnly!=undefined)?params.readOnly:false"
            :propBusinessId="params.businessId" :propLoading = "params.loading" :propDraftsDocId="params.draftsDocId" :propBatchId="params.batchId"
            :propTempBusinessId="params.tempBusinessId" :propFormOpenSource="params.formOpenSource?params.formOpenSource:'form'" :flowModuleNotShowRightPanel="(params.flowModuleNotShowRightPanel==undefined)?false:params.flowModuleNotShowRightPanel"
            :propTaskId="params.taskId" :propProcessDefinitionId="params.processDefinitionId" :autoClaim="(params.autoClaim==undefined)?true:params.autoClaim"  :forceModuleForm="(params.forceModuleForm==undefined)?false:params.forceModuleForm"
            :extParams="params.extParams"  :propEditMode="(params.editMode!=undefined)?params.editMode:true"
            :propDraftsDeptId="params.draftsDeptId" @formActionComplete="formActionComplete" @updatedData='_updatedData'></MwForm>

  </mw-dialog>
</template>
<script>
export default {
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      size:this.params.size?this.params.size:'full',
      dialog:undefined,
      title:this.params.title ? this.params.title : '',
      updatedData:false,
      width:this.params.width,
      height:this.params.height,
    }
  },
  mounted() {
    this.dialog=this.mwRef('dialog');
    setTimeout(()=>{
      this.show();
    },200)
  },
  watch: {

  },
  methods: {
    formConfigLoaded(config){

      if (config && config.content) {
        if(!this.params.width)this.width=config.content.dialogWidth;
        if(!this.params.height)this.height=config.content.dialogHeight;
      }
    },
    setSize(val){
      if(this.size!='full')
        this.size=val;
    },

    getTitle(title){
      if(!this.title){
        this.title=title;
      }
    },
    beforeRender:function($form){
      var me=this;
      this.$form=$form;
      if(me.params.isNewCallback && me.params.func){
        me.params.func.call(me,$form);
      }
    },
    beforeClose(done){
      var me=this;
      var editMode=me.mwRef('form').getEditMode();
      if(!editMode){
        if(me.params.secondfunc){
          if(me.params.secondfunc(me.updatedData, me.$form,done)===false) return;
        }
        me.resetForm();
        done();
      }else{
        me.mwRef('form').noticeButtonEvent('openDialog');
        if(me.mwRef('form').getFormValueChange()){
          PF.confirm($lang('确认退出编辑？'),$lang("提示")).then(function(){
            if(me.params.secondfunc){
              me.params.secondfunc(me.updatedData, me.$form)
            }
            me.resetForm();
            done();
          },function(){});
          // me.mwConfirm($lang('确认退出编辑？')).then(_ => {
          //   if(me.params.secondfunc){
          //     me.params.secondfunc(me.updatedData, me.$form)
          //   }
          //   me.resetForm();
          //   done();
          // }).catch(_ => {

          // });
        }else{ //待办列表打开表单关闭
          if(me.updatedData && me.params.secondfunc){
            if(me.params.secondfunc(me.updatedData, me.$form,done)===false) return;
          }
          me.resetForm();
          done();
        }
      }
    },
    resetForm(){
      this.params.moduleId='';
      let form=this.mwRef('form');
      this.mwRef('dialog').hide();
      form.$emit("dialogClose");
      form.resetForm();
    },
    _updatedData(isRefresh){
      this.updatedData=isRefresh;
    },
    formActionComplete($form,data){
      let me=this;
      if(!me.params.isNewCallback && me.params.func){
        me.params.func($form,data)
      }
      this.resetForm();
    },
    show(){
      this.mwRef('dialog').show();
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/form/form.vue